import { Alert, List, Stack, Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";

const Term = ({ title, children }) => {
  const { t } = useTranslation();
  return (
    <List.Item>
      <Text size="sm" component="span" weight={600}>
        {t(title)}
      </Text>
      <Text size="sm" component="span">
        {": "}
        {children}
      </Text>
    </List.Item>
  );
};

const NoMoreParentGuide = ({
  systemLabel = "Top Upline in the team",
  companyName = "",
}) => {
  const { t } = useTranslation();
  const company = companyName
    ? `${t("the company user group")} ${companyName}`
    : t("the company user group configured for this system");

  return (
    <Alert color="gray" title={t("When an upper level has no parent")} radius="md">
      <Stack spacing="sm">
        <div>
          <Text size="sm" weight={600} mb={4}>
            {t("Key terms")}
          </Text>
          <List spacing={4} size="sm">
            <Term title="Producer">
              {t("the consultant who wrote the business.")}
            </Term>
            <Term title="Upline">{t("the producer’s direct parent.")}</Term>
            <Term title="Upper level">
              {t(
                "a plan row (Upper 1, Upper 2, …) that pays the matching generation in the parent chain."
              )}
            </Term>
            <Term title="No more parent">
              {t(
                "an Upper level whose generation does not exist. Example: the plan has Upper 4, and the producer only has Alice and Bob."
              )}
            </Term>
            <Term title="Top Upline row">
              {t("the plan row of type Top Upline. It is not an Upper 1–4 row.")}
            </Term>
            <Term title="Parent-chain root">
              {t(
                "the last real parent, the person who has no parent. With Alice then Bob, that is Bob. With ten uplines, that is Upline 10."
              )}
            </Term>
            <Term title="Company">
              {company}
              {". "}
              {t("This is not the plan’s Remain row.")}
            </Term>
            <Term title="Remain row">
              {t(
                "the plan row marked Remain. It keeps its own percentage and the rounding remainder. This option does not move that money."
              )}
            </Term>
          </List>
        </div>
        <div>
          <Text size="sm" weight={600} mb={4}>
            {t("Payee options")}
          </Text>
          <Text size="xs" color="dimmed" mb={6}>
            {t(
              "Example: the plan has Upper 1–4 and a Top Upline row. Only Alice (direct upline) and Bob (Alice’s parent) exist."
            )}
          </Text>
          <List spacing={4} size="sm">
            <Term title="Use system default">
              {t("this plan follows the system setting, currently")} {t(systemLabel)}.
            </Term>
            <Term title="Company">
              {t(
                "Upper 3 and Upper 4 pay the company user group. The Top Upline row still pays Bob."
              )}
            </Term>
            <Term title="Upline">
              {t(
                "Upper 3 and Upper 4 pay Alice. If the producer has no parent, those rows pay the company. The Top Upline row still pays the chain root."
              )}
            </Term>
            <Term title="Top Upline in the team">
              {t(
                "Missing Upper rows pay the Top Upline level. That level pays Bob. If the chain is longer than the plan, the Top Upline row pays the chain root (Upline 10), and the uplines between the plan and that root get nothing."
              )}
            </Term>
            <Term title="Top Upline in the plan">
              {t(
                "With only Alice and Bob, missing Upper rows pay the Top Upline level, and that level pays Bob. If the chain is longer than the plan, the Top Upline row pays the highest Upper level in this plan (Upline 4). Uplines above that get nothing."
              )}
            </Term>
          </List>
        </div>
      </Stack>
    </Alert>
  );
};

export default NoMoreParentGuide;
